export class FlightStats {
}
//# sourceMappingURL=flight_stats.js.map